import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const depositValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const { depositValue } = ctx.form.values
    if (isNil(depositValue)) {
      return '保证金不能为空'
    }
    if (depositValue < 0) {
      return '保证金必须大于等于0'
    }
    return null
  }
}
